import * as types from 'misc/types';
import * as actions from 'misc/actions';

const status_check = (state = actions.initial(), action) => {
    switch (action.type) {
        case types.SAGA_STATUS_CHECK.REQUEST:
            return actions.load(state);
        case types.SAGA_STATUS_CHECK.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_STATUS_CHECK.FAILURE:
            return actions.error(state, action.error);
        default:
            return state;
    }
};

export default status_check;



// WEBPACK FOOTER //
// ./src/reducers/status_check.js